var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagIt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3666.77,-4098.39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,3184,2952)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.222222,0,0,1.64956,459.904,-893.555)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "rgb(248,68,68)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.904,920L402.904,920L402.904,953L552.904,953L552.904,920ZM518.649,922.512L518.649,950.488C518.649,950.488 437.159,950.488 437.159,950.488C437.159,950.488 437.159,922.512 437.159,922.512L518.649,922.512Z",
    style: {
      fill: "rgb(248,68,68)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,3184,2952)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.222222,0,0,1.64956,426.571,-893.555)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.83704,3184,2952)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.222222,0,0,1.64956,393.238,-893.555)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.904,
    y: 920,
    width: 150,
    height: 33,
    style: {
      fill: "rgb(55,204,36)"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIt);
export default __webpack_public_path__ + "static/media/flag_it.fa8d8dc69d78e235ba4fc3f2909fdfb4.svg";
export { ForwardRef as ReactComponent };